import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { AppThunk } from '../actions';

import { TrendExportActions } from '../actions/trend-export-actions';

type exportTrendChannel = Array<{ deviceId: string; channelIds: number[] }>;

export const TrendsExportThunks = {
    trendExportData: (
        siteId: string,
        noOfDays: number,
        trendChannel: exportTrendChannel,
        authHelper: AuthHelper
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(TrendExportActions.trendExportStarted());

        const payload = await ApiRequests.getTrendsSiteExportData(
            {
                siteId: siteId,
                days: noOfDays,
                channels: trendChannel,
            },
            { authHelper }
        );
        if (payload.ok) {
            dispatch(TrendExportActions.trendExportSucceeded(payload.response.data.url));
        } else {
            dispatch(TrendExportActions.trendExportFailed());
        }
    },
    getTrendsDeviceExportData: (
        deviceId: string,
        noOfDays: number,
        channels: number[],
        authHelper: AuthHelper
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(TrendExportActions.trendExportStarted());

        const payload = await ApiRequests.getTrendsDeviceExportData(
            {
                deviceId: deviceId,
                days: noOfDays,
                channels: channels,
            },
            { authHelper }
        );
        if (payload.ok) {
            dispatch(TrendExportActions.trendExportSucceeded(payload.response.data.url));
        } else {
            dispatch(TrendExportActions.trendExportFailed());
        }
    },
};
